import CrudRepository from './CrudRepository'
export default class SignupRepository extends CrudRepository {
  constructor () {
    super('api/users/signup')
  }
}
